import React, {useEffect, useState} from "react";
import {observer} from "mobx-react";
import {Layout, Modal, Menu, Descriptions} from "antd";
import * as THREE from "three";
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import Sider from "antd/es/layout/Sider";
import styled from "styled-components";
import type { MenuProps } from 'antd';
type MenuItem = Required<MenuProps>['items'][number];
function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: 'group',
): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    } as MenuItem;
}

const infoList:any = {
    'mujin': { name: '木槿', ldName: 'Hibiscus syriacus Linn.', id: '0001' },
    'lingzhi': { name: '灵芝', ldName: 'Ganoderma lucidum', id: '0002' },
    'rock': { name: '石材', ldName: 'granum', id: '0003' },
}

const Comment: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    useEffect(() => {
        setTimeout(()=> {
            draw();
        }, 20)
        return;
    }, [])
    let [modelInfo, setModelInfo] = useState({ name: '木槿', ldName: 'Hibiscus syriacus Linn.', id: '0001' });
    let modelType = "mujin"

    const items: MenuProps['items'] = [
        getItem("模型列表", "model",null,[
            getItem("木槿", "mujin"),
            getItem("灵芝", "lingzhi"),
            getItem("石材", "rock"),
        ])
    ];

    const draw = () => {
        var Scene: any, camera: any, renderer: any;
        let canvasBox: any = document.getElementById('canvascontainer');
        let childNodes = canvasBox.childNodes;
        for (let i = 0, len = childNodes.length; i < len; i++) {
            canvasBox.removeChild(childNodes[i]);
        }
        init();
        initcamera();

        function init() {
            Scene = new THREE.Scene();
            camera = new THREE.PerspectiveCamera(75, canvasBox.offsetWidth /canvasBox.offsetHeight, 0.1, 1000);
            renderer = new THREE.WebGLRenderer({alpha: true, antialias: true});
            renderer.setSize(canvasBox.offsetWidth, canvasBox.offsetHeight);
            canvasBox.appendChild(renderer.domElement);

            var light = new THREE.DirectionalLight(0xffffff);   //光源颜色
            light.position.set(100, 100, 100);   //光源位置
            Scene.add(light);   //光源添加到场景中
        }

        function initcamera() {
            camera.position.set(5, 5, 5);
            camera.lookAt(10, 0, 0);
            var controls = new OrbitControls(camera, renderer.domElement);
            controls.autoRotate = true;
        }

        var mixer: any;

        function initEarth() {
            let fileUrl = getModelByType();
            let fileList = fileUrl.split('.');
            let len = fileList.length;
            let fileName = fileList[len-1].toLowerCase();
            let loder = fileName === 'fbx' ? new FBXLoader() : new GLTFLoader();
            loder.load(fileUrl, function (obj: any) {
                // console.log(obj)
                //获取模型，并添加到场景
                var model = fileName === 'fbx' ? obj : obj.scenes[0];
                const box = new THREE.Box3().setFromObject(model);
                const x = (box.max.x - box.min.x);
                const y = (box.max.y - box.min.y);
                const z = (box.max.z - box.min.z);
                const maxDim = Math.max(x, y, z);
                const scale = 8 / maxDim;
                model.scale.set(scale, scale, scale);
                Scene.add(model);
                //将模型绑定到动画混合器里面
                mixer = new THREE.AnimationMixer(model);
                //同时将这个外部模型的动画全部绑定到动画混合器里面
                for (var i = 0; i < obj.animations.length; i++) {
                    mixer.clipAction(obj.animations[i]).play();
                }
            })
        }

        initEarth();
        var clock = new THREE.Clock();
        var animate = function () {
            requestAnimationFrame(animate);
            var time = clock.getDelta();
            if (mixer) {
                mixer.update(time);
            }
            renderer.render(Scene, camera);
        };
        animate();
    }
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const onMenuSelect = (info:any)=> {
        modelType = info.key+""
        setModelInfo(infoList[modelType])
        draw()
    }
    const getModelByType = () => {
        if (modelType === "mujin") {
            return "../home/mujin/MuJin.FBX"
        } else if (modelType === "lingzhi") {
            return "../home/renshen/778431-0825.fbx"
        } else if (modelType === "rock") {
            return "../home/rock/scene.gltf"
        }
        return ""
    }
    return (
        <Wrapper style={{ width: '100%' }}>
            <Layout style={{ flex: '1' }}>
                <Sider theme={"light"} collapsible={false} width={"238px"}
                       style={{background: "#ffffff", marginTop: "1px"}}>
                    <div style={{overflow: "scroll", height: "86%", paddingTop: "20px"}}>
                        <Menu
                            theme={"light"}
                            mode={"inline"}
                            openKeys={['model']}
                            items={items}
                            defaultSelectedKeys={['mujin']}
                            onSelect={onMenuSelect}
                        />
                    </div>
                </Sider>
                
                <MainContent>
                    <div id="canvascontainer" style={{width: '100%', flex: '1', backgroundColor: '#969696', overflow: 'hidden'}}></div>
                    <div className="informationContent">
                        <Descriptions 
                            title="模型信息" 
                            column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }} 
                            bordered={true}
                            labelStyle={{width: '120px'}}>
                            <Descriptions.Item label="中文名">{ modelInfo.name }</Descriptions.Item>
                            <Descriptions.Item label="上传人">张三</Descriptions.Item>
                            <Descriptions.Item label="上传号">{ modelInfo.id }</Descriptions.Item>
                            <Descriptions.Item label="上传日期">2023-08-30</Descriptions.Item>
                            <Descriptions.Item label="省市">湖北省</Descriptions.Item>
                            <Descriptions.Item label="区县">武汉市</Descriptions.Item>
                        </Descriptions>
                    </div>
                </MainContent>
            </Layout>
            <Modal title="详情信息" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null}>
                <p>模型信息：</p>
                <p>尺寸：</p>
                <p>年份：</p>
            </Modal>
        </Wrapper>
    )
}

export default observer(Comment);

const MainContent = styled.div`
    & {
        width: 100%;
        margin: 15px;
        background-color: #fff;
        display: flex;
        align-items: stretch;
        overflow: hidden;
        .informationContent {
            width: 400px;
            padding: 15px;
        }
    }
`;

const Wrapper = styled.div`
  & {
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .ant-menu {
        background: #fff !important;
        font-size: 16px !important;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        color: rgba(0, 0, 0, 0.88);
        line-height: 70px !important;
        display: flex;
        justify-content: center;
        flex-direction: column;
    }
    .ant-menu-light.ant-menu-horizontal >.ant-menu-item {
        margin-right: 30px;
        height: 70px; 
        text-align: center;
        padding: 0 32px;
        display: flex;
        align-items: center;
        flex-direction: column;
        border-radius: 6!important;
    }
    .ant-menu-light.ant-menu-horizontal >.ant-menu-item:last-child {
        margin-right: 0;
    }
    .ant-menu-light.ant-menu-horizontal >.ant-menu-item::after {
        border: 0;
        border-radius: 6!important;   
    }
    .ant-menu-light .ant-menu-item:hover:not(.ant-menu-item-selected):not(.ant-menu-submenu-selected), :where(.css-dev-only-do-not-override-26rdvq).ant-menu-light .ant-menu-submenu-title:hover:not(.ant-menu-item-selected):not(.ant-menu-submenu-selected){
        color: rgba(0, 0, 0, 0.88);
        background-color: #E5F3FF !important;
    }
    
    .ant-menu-item-selected {
        background: #1990FF !important;
        color: white !important;
        border-radius: 6 !important;   
    }
    .ant-menu-light:not(.ant-menu-horizontal) .ant-menu-submenu-title:hover{
        background-color: #E5F3FF !important;
    }

    .ant-layout-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1;
    }

    .homeFooter {
      background-color: #1E343A;
      display: flex;
      width: 100%;
      height: 70px;
      text-align: center;
      align-items: center;
      justify-content: center;
    }
  }
`;